<template>
    <div>
        <h1 style="text-align: center;">Infographic6 Component Editor</h1>
        <div v-if="isLoading" class="loading">PLEASE WAIT...</div>
        <div>
            <div ref="cntTitle">
                <h2>Title</h2>
                <div><input type="text" v-model="title" style="width: 100%"></div>
            </div>
            <div ref="cntThumb">
                <h2>Thumbnail</h2>
                <div><img :src="thumbnail.data" height="200px" width="100%" style="object-fit: contain;"></div>
                <div><input type="file" ref="thumbsel" v-on:change="changeImage(thumbnail, 'thumbsel');changeImage(img, 'thumbsel');" accept="image/jpeg,image/png,image/tif" style="width: 100%; color: black;"></div>
            </div>
            <hr>
            <div class="x-cardbox">
                <div v-for="(slot, i) in data" :key="'cntCard-' + i" :ref="'cntCard-' + i" class="x-card">
                    <h2>Marker #{{i+1}}</h2>
                    <div style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
                        <Minimap :img="thumbnail.data" :x="slot.marker.x" :y="slot.marker.y"></Minimap>
                        <span style="width: 100%;">X: 
                          <input type="range" min="0" max="750" v-model="slot.marker.x" style="width: 400px;">
                          <input type="text" v-model="slot.marker.x" style="width: 40px;">
                          </span>
                        <span style="width: 100%;">Y: 
                          <input type="range" min="0" max="550" v-model="slot.marker.y" style="width: 400px;">
                          <input type="text" v-model="slot.marker.y" style="width: 40px;">
                        </span>
                    </div>
                    <div :ref="'cntDesc' + i">
                        <input type="text" v-model="slot.header" placeholder="Heading..." style="width: 100%; margin: 0.25em 0;">
                        <quill-editor v-model="slot.description" placeholder="Description...">
                        </quill-editor>
                    </div>
                    <div>
                        <button @click="deleteSlot(i)" style="width: 100%; font-size: 1.2em; background: maroon; color: white;">Delete Slot</button>
                    </div>
                    <hr>
                </div>
            </div>
            <div>
                <button @click="addNew()" class="submit-btn">Add New Marker</button>
                <button @click="submitThis()" class="submit-btn">Submit</button>
                <hr>
            </div>
        </div>
    </div>
</template>

<script>
import {Functions} from './functions.js';
import Minimap from './minimap.vue';
export default {
    name: "Infographic6AddEditComponent",
    props: ["ID"],
    components:{Minimap},
    data: () => ({
        isLoading: true,
        title: "",
        id: undefined,
        data: [],
        thumbnail: {
            file: undefined,
            data: "",
            publicUrl: "",
            uploadUrl: ""
        },
        img: {
            file: undefined,
            data: "",
            publicUrl: "",
            uploadUrl: ""
        },
        functions: undefined,
        buffer: undefined
    }),
    mounted: function(){
        this.functions = new Functions();
        if(this.ID){
            console.log("EDITING");
            this.functions.getComponent(this.ID, (data) => {
                console.log(data);
                this.id = data.contentId;
                this.title = data.title;
                this.thumbnail.publicUrl = data.rdsDat[0].Thumbnail;
                this.img.publicUrl = data.data.img;
                this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg,image/jpg,image/png,image/tif", "getObject", (thumbBuff) => {
                    this.thumbnail.data = (thumbBuff.signedUrl);
                    this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg,image/jpg,image/png,image/tif", "putObject", (thumbBuff1) => {
                        this.thumbnail.uploadUrl = thumbBuff1.signedUrl;
                        this.functions.getSignedUrl("ttedu-public-uploads", this.img.publicUrl.replace("https://ttedu-public-uploads.s3.amazonaws.com/", ""), "image/jpeg,image/jpg,image/png,image/tif", "putObject", (dat) => {
                            this.img.uploadUrl = dat.signedUrl;
                            this.getImageSignedURL(0, data.data);
                        });
                    });
                });
            });
        }else{
            console.log("Create New");
            
            this.functions.getThumbURL((dat) => {
                this.thumbnail.publicUrl = dat.key;
                this.thumbnail.uploadUrl = dat.signedUrl;
                this.functions.getImageURL((dat) => {
                    this.img.publicUrl = dat.key;
                    this.img.uploadUrl = dat.signedUrl;
                    this.addNew();
                }, err => console.error(err));
            });
        }
    },
    methods: {
        getImageSignedURL(i, data){
            if(i >= data.markers.length){
                this.isLoading = false;
                return null;
            }
            console.log(data);
            this.data.push({
                header: data.markers[i].title,
                description: data.markers[i].descr,
                marker: {
                    x: data.markers[i].pos.y,
                    y: data.markers[i].pos.x
                }
            });
            this.getImageSignedURL(i+1, data);
            return null;
            if(data.notes[i].picture != null){
                this.functions.getSignedUrl("ttedu-public-uploads", data.notes[i].picture.replace("https://ttedu-public-uploads.s3.amazonaws.com/", ""), "image/jpeg,image/png,image/tif", "putObject", (dat) => {
                    this.data[i].img.uploadUrl = dat.signedUrl;
                    this.getImageSignedURL(i+1, data);
                });
            }else{
                this.functions.getImageURL((dat) => {
                    this.data[i].img.publicUrl = dat.key;
                    this.data[i].img.uploadUrl = dat.signedUrl;
                    this.getImageSignedURL(i+1, data);
                });
            }
        },
        addNew: function(){
            this.isLoading = true;
            this.functions.getImageURL((dat) => {
                this.data.push({
                    img: {
                        file: undefined,
                        data: "",
                        publicUrl: dat.key,
                        uploadUrl: dat.signedUrl
                    },
                    marker: {
                        x: 0,
                        y: 0
                    },
                    picture: null,
                    header: "",
                    description: "",
                    offset: -1,
                    ID: -1
                });
                this.isLoading = false;
            });
        },
        changeImage: function(_selIMG, selref){
            var reader = new FileReader();
            reader.onload = (e) => {
                console.log(_selIMG);
                if("data" in _selIMG) _selIMG.data = e.target.result;
                else _selIMG.img.data = e.target.result;
            }
            if(this.$refs[selref].length){
                reader.readAsDataURL(this.$refs[selref][0].files[0]);
                _selIMG.img.file = this.$refs[selref][0].files[0];
            }else{
                reader.readAsDataURL(this.$refs[selref].files[0]);
                _selIMG.file = this.$refs[selref].files[0];
            }
        },
        deleteSlot: function(i){
            let c = confirm("Are you sure you want to delete Timeline Slot #" + (i+1));
            if(c){
                this.data.splice(i, 1);
            }
        },
        deleteImg: function(i){
            let c = confirm("Are you sure you want to delete Image from Slot #" + (i+1));
            if(c){
                this.data[i].img.file = undefined;
                this.data[i].img.data = "";

                this.data[i].picture = null;
                this.$refs['imgsel' + i][0].value = '';
            }
        },
        submitThis: function(){
            // console.log(this.composeData());
            // return null;
            if(this.ID){
                //update Logic
                this.updateThis();
            }else{
                this.createNew();
            }
        },
        updateThis: function(){
            let hasError = false;
            if(this.title.trim() == "") {this.$refs.cntTitle.classList.add("has-error"); hasError = true;}
            else this.$refs.cntTitle.classList.remove("has-error")
            if(this.data.length == 0){alert("No slots available for timeline, select minimum 1"); hasError = true;}

            this.data.forEach((slot, i) => {
                if(slot.header.trim() == "" || slot.description.trim() == ""){
                    this.$refs["cntCard-" + i][0].classList.add("has-error");
                    hasError = true;
                }else{
                    this.$refs["cntCard-" + i][0].classList.remove("has-error");
                }
            });

            if(!hasError){
                console.log("No errors, proceeding to upload");
                this.isLoading = true;
                setTimeout(() => {
                    if(this.thumbnail.file != undefined){
                        this.functions.upload(this.img.uploadUrl, this.img.file, (dat) => {
                            this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                                this.uploadImages(0);
                            });
                        });
                    }else{
                        this.uploadImages(0);
                    }
                }, 500);
            }else{
                alert("Please fix all the errors");
            }
        },
        createNew: function(){
            let hasError = false;
            if(this.title.trim() == "") {this.$refs.cntTitle.classList.add("has-error"); hasError = true;}
            else this.$refs.cntTitle.classList.remove("has-error")
            if(this.thumbnail.file == undefined) {this.$refs.cntThumb.classList.add("has-error"); hasError = true;}
            else this.$refs.cntThumb.classList.remove("has-error")
            if(this.data.length == 0){alert("No slots available for timeline, select minimum 1"); hasError = true;}

            this.data.forEach((slot, i) => {
                if(slot.description.trim() == ""){
                    this.$refs["cntCard-" + i][0].classList.add("has-error");
                    hasError = true;
                }else{
                    this.$refs["cntCard-" + i][0].classList.remove("has-error");
                }
            });

            if(!hasError){
                console.log("No errors, proceeding to upload");
                this.isLoading = true;
                setTimeout(() => {
                    this.functions.upload(this.img.uploadUrl, this.img.file, (dat) => {
                        this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                            this.uploadImages(0);
                        });
                    });
                }, 500);
            }
        },
        uploadImages: function(i){
            let componentData = this.composeData();
            if(this.ID){
                this.functions.updateComponent(this.ID, componentData, (dat) => {
                    console.log(dat);
                    this.$router.push("/editors/component/infographic6");
                });
            }else{
                this.functions.addComponent(componentData, (dat) => {
                    console.log(dat);
                    this.$router.push("/editors/component/infographic6");
                });
            }
            return null;
            if(i < this.data.length){
                if(this.data[i].img.file != undefined){
                    //upload the file
                    this.functions.upload(this.data[i].img.uploadUrl, this.data[i].img.file, (dat) => {
                        this.uploadImages(i + 1);
                    });
                }else{
                    this.uploadImages(i+1);
                }
            }else{
                let componentData = this.composeData();
                if(this.ID){
                    this.functions.updateComponent(this.ID, componentData, (dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/infographic6");
                    });
                }else{
                    this.functions.addComponent(componentData, (dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/infographic6");
                    });
                }
            }
        },
        composeData: function(){
            let compData = {
                markers: [],
                heading: this.title,
                img: this.img.publicUrl
            };
            this.data.forEach((d,i) => {
                compData.markers.push({
                    title: d.header,
                    descr: d.description,
                    pos: {
                        x: d.marker.y,
                        y: d.marker.x
                    }
                });
            });
            
            return {
                ContentType: "INTERACTIVE",
                Title: this.title,
                Thumbnail: this.thumbnail.publicUrl,
                Component: "infographic6",
                Data: compData
            };
        },
    }
}
</script>

<style scoped>
textarea{
    width: 100%;
}
    .quill-editor{
        background: white;
        color: black;
    }
    .ql-container.ql-snow{
        background: white !important;
    }
    .submit-btn{
        width: 100%;
        height: 2em;
        font-size: 1.5em;
        font-weight: 800;
        margin-top: 0.5em;
    }
    .has-error{
        border: red 5px solid !important;
        box-sizing: border-box;
    }
    .has-error::after{
        content: "Missing content/invalid content.";
        color: red;
        background: white;
        font-weight: 800;
    }
    hr{
        border: solid 2px white;
    }
    h2{
      color: black;
    }
    .loading{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        justify-content: center;
        text-align: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        display: flex;
        font-size: 4em;
        font-weight: 900;
    }
    .x-cardbox{
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
    }
    .x-card {
        flex: 50%;
        text-align: center;
        box-sizing: border-box;
        border: 1px solid white;
        background: rgb(0,150,20);
        background: linear-gradient(6deg, rgba(0,150,20,1) 0%, rgba(0,0,0,1) 100%);
    }
    .x-card img{
        background: gray;
        object-fit: contain !important;
        width: 400px;
        height: 250px;
    }
    .x-card .size2{
        width: 400px !important;
    }
</style>